/**
 * Camembert générique à catégories dynamiques (palette de couleurs cyclique)
 * - utilisé pour les répartitions Accidentologie (Classification, catégorie
 * de risque "Cet incident est lié à"...) dont les valeurs ne sont pas un
 * enum fixe connu à l'avance (contrairement à FindingsPieChart).
 */
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PALETTE = ["#0B5394", "#EF4444", "#F59E0B", "#10B981", "#8B5CF6", "#06B6D4", "#EC4899", "#84CC16", "#64748B", "#F97316"];

export default function CategoryPieChart({ title, data = [], testId, colorMap }) {
  return (
    <Card data-testid={testId} className="border-slate-200 shadow-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-slate-500">{title}</CardTitle>
      </CardHeader>
      <CardContent className="h-[300px] pt-0">
        {data.length === 0 ? (
          <div className="flex h-full items-center justify-center text-sm text-slate-400">Aucune donnée</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={80} paddingAngle={2}>
                {data.map((entry, idx) => (
                  <Cell key={entry.name} fill={colorMap?.[entry.name] || PALETTE[idx % PALETTE.length]} />
                ))}
              </Pie>
              <Tooltip contentStyle={{ borderRadius: 8, borderColor: "#E2E8F0", fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 10 }} />
            </PieChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
